import { createSlice } from "@reduxjs/toolkit";
import {
  getCandidateIntegrityScore,
  computeCandidateIntegrityScore,
} from "../actions/candidate-integrity-score-actions";

const initialState = {
  data: null,
  isLoading: false,
  error: null,
};

const candidateIntegrityScoreSlice = createSlice({
  name: "candidateIntegrityScore",
  initialState,
  reducers: {
    clearIntegrityScore: (state) => {
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCandidateIntegrityScore.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getCandidateIntegrityScore.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(getCandidateIntegrityScore.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(computeCandidateIntegrityScore.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(computeCandidateIntegrityScore.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(computeCandidateIntegrityScore.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearIntegrityScore } = candidateIntegrityScoreSlice.actions;
const candidateIntegrityScoreSliceReducer = candidateIntegrityScoreSlice.reducer;
export default candidateIntegrityScoreSliceReducer;
